import {Backend, NetworkError} from '@common/backend'
import {globals} from '@extensions/globals-base'

export const checkAvailableUrl = async (url: string): Promise<boolean> => {
  const companyId = globals.getCompanyId()
  const useCurrentHost = false

  try {
    await Backend.requestRawJSON({
      url,
      method: 'POST',
      data: {...Backend.loadCred(), companyId, taskIds: []},
      useCurrentHost,
      attemptsMade: 10
    })
  } catch (e) {
    if (e instanceof NetworkError && e.status === 404) {
      return false
    }
  }

  return true
}
